export const reportSvg = (
  <svg width="76" height="93" viewBox="0 0 76 93" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M-0.499348 74.3778C-7.77352 74.3721 -14.7483 71.4788 -19.8919 66.3332C-25.0355 61.1876 -27.9277 54.2101 -27.9333 46.9331C-27.922 39.6578 -25.028 32.6841 -19.8857 27.5397C-14.7433 22.3953 -7.77178 19.5002 -0.499348 19.4889C6.77679 19.4945 13.7535 22.3869 18.9005 27.5319C24.0475 32.6769 26.9442 39.6541 26.9555 46.9331C26.9442 54.212 24.0475 61.1892 18.9005 66.3343C13.7535 71.4793 6.77679 74.3721 -0.499348 74.3778Z"
      stroke="#FF1ABE" strokeWidth="0.865498" strokeMiterlimit="10" />
    <path
      d="M-0.495565 65.1333C-5.16635 65.1296 -9.64489 63.2414 -12.9476 59.8832C-16.2504 56.525 -18.1074 51.9713 -18.1111 47.2221C-18.1038 42.474 -16.2456 37.9227 -12.9436 34.5653C-9.64166 31.2079 -5.16523 29.3185 -0.495565 29.3111C4.17648 29.3148 8.65627 31.2024 11.9612 34.5602C15.2661 37.918 17.1261 42.4716 17.1334 47.2221C17.1261 51.9725 15.2661 56.5261 11.9612 59.8839C8.65627 63.2417 4.17648 65.1296 -0.495565 65.1333Z"
      fill="#FF1ABE" stroke="#FF1ABE" strokeWidth="0.865498" strokeMiterlimit="10" />
    <path
      d="M40.1386 1H74.9645L75 35.9155L42.0559 35.9155C42.8599 39.3404 43.2602 42.8484 43.2485 46.3674C43.2485 52.323 42.0814 58.2203 39.8132 63.7224C37.5451 69.2245 34.2206 74.2238 30.0297 78.4345C25.8388 82.6452 20.8635 85.985 15.3881 88.263C9.91276 90.5411 4.04447 91.7127 -1.88156 91.7111C-13.8477 91.7111 -25.3239 86.9339 -33.7852 78.4304C-42.2466 69.9268 -47 58.3932 -47 46.3674C-47 34.3415 -42.2466 22.8083 -33.7852 14.3047C-25.3239 5.80114 -13.8477 1.02397 -1.88156 1.02397C-0.414585 1.02397 1.02869 1.0958 2.45989 1.23964L2.39991 1.02397H29.6762V16.2343L40.1386 16.2344V1Z"
      stroke="#FF1ABE" strokeWidth="0.865498" strokeMiterlimit="10" />
  </svg>
);

export const supportSvg = (
  <svg width="75" height="104" viewBox="0 0 75 104" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.4938 103.366C50.4927 103.366 74 80.4551 74 52.1768C74 23.8985 50.4927 1 21.4938 1C-7.50515 1 -31 23.9109 -31 52.1768C-31 80.4427 -7.49273 103.366 21.5062 103.366H21.4938Z"
      stroke="#00DFAF" strokeWidth="0.865498" strokeMiterlimit="10" />
    <path
      d="M11.7057 35.7182C14.4515 34.1527 17.57 33.2954 20.8501 33.2954C20.9371 33.2954 21.0116 33.2954 21.0986 33.2954C25.1615 33.3451 29.0379 34.6745 32.3056 37.0725L42.0464 27.3316C36.182 22.4488 28.9137 19.7402 21.2726 19.6408C14.1533 19.529 7.39433 21.7157 1.82812 25.8531C4.43728 28.4622 8.46284 32.4878 11.7057 35.7306V35.7182Z"
      fill="#00DFAF" />
    <path
      d="M46.4447 31.7299L36.7039 41.4707C41.1891 47.6333 41.6613 55.7341 38.0581 62.0707L47.9357 71.9482C56.6826 60.0827 56.1483 43.3965 46.4571 31.7299H46.4447Z"
      fill="#00DFAF" />
    <path
      d="M6.32567 63.0523C3.94016 59.7846 2.5983 55.9081 2.54861 51.8453C2.48648 47.3103 4.02713 43.0611 6.8972 39.7065L-2.79396 30.0153C-8.27319 36.004 -11.2178 43.7693 -11.1184 52.0192C-11.019 59.6728 -8.31046 66.9412 -3.42761 72.7931L6.31325 63.0523H6.32567Z"
      fill="#00DFAF" />
    <path
      d="M34.07 66.8667C27.5098 72.4453 17.8187 72.5944 10.7243 67.4382C7.28265 70.8798 3.26952 74.893 0.983398 77.1791C7.13356 82.2856 14.6753 84.8575 22.1797 84.8575C29.9575 84.8575 37.698 82.0868 43.7612 76.5579L34.07 66.8667Z"
      fill="#00DFAF" />
  </svg>
);

export const protectSvg = (
  <svg width="69" height="111" viewBox="0 0 69 111" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M68 1V88.1402L23 109.582L-22 88.1402V1H68V1Z" stroke="#00D1FF" strokeWidth="0.865498"
      strokeMiterlimit="10" />
    <path
      d="M25.9772 19.2559H22.9998H-4.59302V51.6412V57.2695V75.2382L22.9998 88.3882L50.5927 75.2382V51.6412V50.4007V19.2559H25.9772Z"
      stroke="#00D1FF" strokeWidth="0.865498" strokeMiterlimit="10" />
    <g filter="url(#filter0_d_1875_5065)">
      <path d="M23 88.375L50.5929 75.238V51.6411H23V88.375Z" fill="#00D1FF" />
      <path d="M22.9998 19.2559H-4.59302V51.6412H22.9998V19.2559Z" fill="#00D1FF" />
    </g>
    <defs>
      <filter id="filter0_d_1875_5065" x="-7.95115" y="15.8977" width="61.9021" height="75.8353"
        filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset />
        <feGaussianBlur stdDeviation="1.67907" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1875_5065" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1875_5065"
          result="shape" />
      </filter>
    </defs>
  </svg>
)